var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDuplicateblur(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 19.152,
    viewBox: "0 0 17 19.152",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Duplicate",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2722",
    "data-name": "Group 2722",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2063",
    "data-name": "Path 2063",
    d: "M11.7,19.152H2.416A2.43,2.43,0,0,1,0,16.744V4.92A2.428,2.428,0,0,1,2.414,2.5H11.7A2.426,2.426,0,0,1,14.12,4.918V16.74A2.428,2.428,0,0,1,11.7,19.152ZM2.418,3.959a.969.969,0,0,0-.963.964V16.74a.969.969,0,0,0,.964.958H11.7a.969.969,0,0,0,.963-.961V4.92a.967.967,0,0,0-.964-.961ZM16.273,15.147a.727.727,0,0,1-.727-.727V3.141a1.688,1.688,0,0,0-1.686-1.686H4.74A.727.727,0,1,1,4.74,0h9.119A3.144,3.144,0,0,1,17,3.141V14.42A.727.727,0,0,1,16.273,15.147Z",
    transform: "translate(0 0)",
    fill: "#333"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDuplicateblur);
export default __webpack_public_path__ + "static/media/Duplicate blur.e415b0e11d78ced0099079db6950d9e6.svg";
export { ForwardRef as ReactComponent };